import { styled } from '@ori-ui/mui';

import { UnifiedSkeleton } from '../../../../components/styles';

export const LinkLabelSkeleton = styled(UnifiedSkeleton)(({ theme }) => ({
  fontSize: theme.typography.fontSize,
}));

export const ListLink = styled(UnifiedSkeleton)({
  height: '18px',
});

export const MobileLinkColumn = styled(UnifiedSkeleton)({
  width: '100%',
  height: '50px',
});
